import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { getKeyHistory } from "domain/keys/api/get-key-history";
import { KeyHistoryRequestDto } from "domain/keys/entities/dtos/key-history-request.dto";

const getKeyHistoryAction = createAsyncThunk(
  "keys/getKeyHistoryAction",
  async (request: KeyHistoryRequestDto, thunkAPI) => {
    try {
      return await getKeyHistory(request);
    } catch (error: any) {
      console.error(error);
      toast.error(i18n.t("toasts.getKeyHistoryError"));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default getKeyHistoryAction;
